export default {
  common: {
    selAll: '全选',
    navTab: '标签页',
    contactNumber: '联系电话',
    max10: '最多添加10个问题',
    oFrequency1: '每次访问出现',
    oFrequency2: '仅首次访问出现',
    oFrequency3: '7天内访问不重复出现',
    oFrequency4: '30天内访问不重复出现',
    oFrequency: '出现频率',
    question: '问题',
    welcome: '欢迎语',
    style: '样式',
    one: '一',
    two: '二',
    three: '三',
    four: '四',
    avatar: '头像',
    qrCode: `小程序码`,
    infoPosition: '信息位置',
    infoDatas: '展示信息',
    datas: '数据',
    ratio: '比例',
    format: '格式',
    cols: '列',
    gap: '间隔',
    news: '新闻',
    business: '业务',
    cases: '案例',
    graphic_carouse: '图文轮播',
    requiredItem: '必填项',
    selected: '选中',
    contactInfo: '联系方式',
    width: '宽',
    height: '高',
    noData: '暂无数据',
    h5URL: 'H5链接',
    mpH5URLTip: '需要在微信公众平台配置业务域名',
    shortLinkTip: 'shortLink:小程序链接。可以通过【小程序菜单】->【复制链接】获取。',
    toTutorial: '查看教程',
    switchLanguage: '切换语言成功',
    companyName: '加推科技',
    sysVersion: '基线版',
    submit: '提交',
    confirm: '确认',
    batch: '批量',
    import: '导入',
    click: '点击',
    cancel: '取消',
    edit: '编辑',
    officialAccount: '公众号',
    delete: '删除',
    details: '详情',
    goBack: '返回',
    goTop: '回到顶部',
    setting: '设置',
    events: '跳转',
    refreshPage: '刷新页面',
    close: '关闭',
    closeCurrent: '关闭当前',
    closeLeft: '关闭左侧',
    closeRight: '关闭右侧',
    closeOthers: '关闭其他',
    closeAll: '关闭所有',
    clue: '线索',
    customer: '客户',
    source: '来源',
    sourceOfClues: '线索来源',
    none: '空',
    name: '名称',
    anonymousFiles: '匿名文件',
    yesterday: '昨日',
    thisWeek: '本周',
    thisMonth: '本月',
    department: '部门',
    times: '次数',
    add: '新增',
    state: '状态',
    available: '上架',
    notAvailable: '下架',
    desc: '描述',
    tag: '标签',
    sticky: '置顶',
    createTime: '创建时间',
    updateTime: '更新时间',
    operate: '操作',
    yes: '是',
    no: '否',
    QRCode: '二维码',
    select: '选择',
    rightClickToDownload: '点击右键进行下载',
    default: '默认',
    miniApp: '小程序',
    browser: '浏览器',
    all: '全部',
    doc: '文档',
    image: '图片',
    type: '类型',
    view: '概览',
    size: '大小',
    permisson: '权限',
    move: '移动',
    staff: '员工',
    phone: '手机号',
    position: '职位',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    new: '新的',
    to: '到',
    upload: '上传',
    uploaded: '已上传',
    repeat: '重新',
    uploading: '正在上传',
    success: '成功',
    enable: '启用',
    disable: '禁用',
    onShelf: '上架',
    downShelf: '下架',
    enterByOneself: '自行进入',
    link: '链接',
    shareLink: '分享链接',
    scanQRcode: '扫码',
    manualEntry: '手工录入',
    card: '名片',
    website: '官网',
    category: '分类',
    wordSpacing: '',
    export: '导出',
    belong: '所属',
    sales: '销售',
    entryMethod: '进入方式',
    beginTime: '开始时间',
    endTime: '结束时间',
    company: '公司',
    remark: '备注',
    customize: '自定义',
    system: '系统',
    sort: '排序顺序',
    moveUp: '上移',
    moveDown: '下移',
    group: '组',
    leaveUserInfo: '留资',
    published: '已发布',
    draft: '草稿',
    notice: '通知',
    title: '标题',
    send: '发送',
    sended: '已下发',
    unsent: '未下发',
    content: '内容',
    receive: '接收',
    sendImmediately: '立即发送',
    sendOnTime: '定时发送',
    sendTime: '下发时间',
    sendUsersCnt: '下发人数',
    sendUsers: '下发人员',
    readUsers: '查看人数',
    readed: '已读',
    unread: '未读',
    role: '角色',
    child: '子',
    parent: '父',
    contain: '包含',
    icon: '图标',
    carousel: '轮播位',
    carouselImage: '轮播图',
    preview: '预览',
    backgroundImage: '背景图',
    page: '页面',
    languageType: '语言类型',
    baseInfo: '基本信息',
    email: '邮箱',
    sex: '性别',
    notSet: '未设置',
    male: '男',
    famale: '女',
    jobNo: '工号',
    address: '地址',
    is: '是否为',
    thumbnail: '缩略图',
    search: '搜索',
    text: '文本',
    zhCN: '中文版',
    en: '英文版',
    number: '序号',
    top: '顶级',
    shareCount: '分享次数',
    pvCount: '客户浏览次数',
    uvCount: '客户浏览人数(获客人数)',
    shareType: '分享类型',
    shareUser: '分享人',
    publishTime: '发布时间',
    shareRecord: '分享记录',
    anonymousUser: '匿名用户',
    salesDepartment: '销售所属部门'
  },
  card: {
    email: '发邮件',
    visit: '去拜访',
    wechat: '微信',
    phone: '手机号码',
    share: '分享名片',
    addContact: '一键存入通讯录',
    tiled: '平铺',
    suspensionStrip: '悬浮条',
    tempTip: '员工在小程序-个人中心中可替换名片模板',
    nav: '导航'
  },
  error: {
    returnToHome: '返回首页'
  },
  tips: {
    qrCodeTip: `长按扫码查看详情`,
    shareSettsTip: `仅针对未获得手机号的客户生效`,
    shareSettsTip2: `不允许销售修改`,
    shareSettsTip3: `客户完整浏览需提供姓名、手机及公司`,
    shareSettsTip4: `客户可直接完整浏览`,
    isAutoShowTip: '用户未授权时主动弹出留资框',
    hideNavTip: '您已关闭所有导航，将不会在小程序中展示导航栏。',
    importFileName: '失败列表',
    deleteTips: '您确认要删除当前项吗？',
    maxTagTips: '最多选择3个标签',
    tagNameLengthTips: '标签名称不能超过6个字符',
    fileNameLengthTips: '文件名称不能超过30个字符',
    uploadImageTypeTips: '上传文件只能是png、jpg、jpeg、bmp、mp4、ppt、pptx、pdf格式',
    uploadFileSizeTips: '上传文件大小不能超过 100MB',
    updateFileTypeTips: '修改文件内容时仅支持重新上传与原文件类型相同格式的文件',
    fileOperateGiveUpTips: '退出将导致已上传的文件失效，你确认退出吗?',
    saveFailTips: '保存失败，请重新保存',
    fileNameEmptyTips: '请输入文件名',
    cannotBeSpaces: '不能为空格',
    cannotBeEmpty: '不能为空',
    timeRangeErrorTips: '结束时间不能小于开始时间',
    cannotExceed8Characters: '不能超过8个字符',
    cannotExceed30Characters: '不能超过30个字符',
    cannotExceed40Characters: '不能超过40个字符',
    cannotExceed200Characters: '不能超过200个字符',
    cannotExceed100Characters: '不能超过100个字符',
    tagDeleteTips: '该标签组包含子标签，无法删除(请先清理子标签后再删除)',
    miniUserVisitTips: '小程序用户访问需提交以下信息才能完整浏览',
    productCarouselImageTip:
      '最多上传5张，文件格式要求png/jpg/jpeg。修改尺寸后请重新上传轮播图，否则可能导致轮播图显示异常。',
    productCarouselEmptyTip: '未上传轮播图',
    selectStaffTips: '请选择人员',
    serverErrorTips: '服务器端错误',
    miniCustomizeDownShelfTips: '你确定要下架吗，下架后请尽快发布新的名片装修',
    websiteDownShelfTips: '你确定要下架吗，下架后请尽快发布新的官网装修',
    updateImageTips: '点击图片进行更换',
    descInputTips: '选填, 限制200字',
    productDescInputTips: '选填, 限制500字',
    uploadNineImageFinishTips: '已上传9张图片（最大可上传9个图片），无法继续上传',
    uploadImageTips: '只能上传jpg/png文件，建议上传图片大小600*900',
    uploadImgTypeTips: '只能上传jpg/png/jpeg文件',
    uploadImgRatioTips: '宽高比为',
    selectLinkTips: '请选择目标子页面',
    uploadNineImageTips: '建议上传图片大小600*900，只能上传jpg/png文件，最多上传9张照片',
    uploadVideoTypeTips: '上传视频必须是mp4格式',
    coverPictureTips:
      '建议上传图片大小600*900，非必填；如果未上传，小程序、APP列表默认取内容第一张图为封面图',
    customizeSaveTips:
      '包含未录入信息的内容项，可能导致显示问题，是否[确认]保存？或者[取消]后重新编辑并保存',
    updatePdfPPTTips: '1）支持导入PDF/PPT，导入后系统自动生成手册图片；2）支持批量导入图片',
    updateContentTips: '请上传/导入宣传册内容',
    backgroundUploadTips: '请上传背景图',
    pleaseUploadTips: '请上传',
    backgroundSelectTips: '请选择背景图',
    brochureUploadFileTypeTips: '上传文件必须是pdf、ppt或图片格式',
    uploadImageSizeTips: '上传图像大小不能超过 5MB',
    uploadFileProcessBeginTips: '只允许上传一个文件, 你已上传',
    uploadFileProcessEndTips: '个文件, 文件大小为',
    requestFailTips: '请求失败',
    caseCustomizeTips: '不能修改案例基本信息编辑栏位置',
    customizeEmptyTips: '内容不能为空，无法删除最后一个元素(可添加新的元素后删除该元素)',
    caseBaseInfoInputTips: '请填写案例基本信息',
    caseNameInputTips: '请填写案例名称',
    caseDescInputTips: '请填写案例描述',
    materialTypeSelectMoreTips: '选择的分类不能超过9个',
    cardCustomizeBaseInfoNoRepeatTips: '个人简介板块不能重复添加',
    cardCustomizeBaseInfoMoveTips: '不能修改名片基本信息编辑栏位置',
    websiteShareImageTips: '设置官网分享缩略图',
    sendUserEmptyTips: '下发人员不能为空',
    roleNoPermissionsTips: '该角色没有勾选菜单(无任何权限),无法绑定用户',
    setPwdTips: '设置角色必须填写登录密码，取消设置将无法设置角色',
    more1Less40Characters: '必须在1到40个字之间',
    more1Less200Characters: '必须在1到200个字之间',
    more1Less10Characters: '必须在1到10个字之间',
    must11Characters: '必须为11位数字',
    closeBeforeSaveRoleTips: '关闭将导致已设置角色不保存，是否关闭',
    setLeaderTips: '部门leader(用于接收部门小结)',
    setLeaderEmptyTips: '未设置所管理的部门',
    videoOneUploadTips: '只支持上传一个视频',
    componentContentEmptyTips: '组件内容为空、',
    selectErrorTips: '选择无效，请重新选择',
    clickForDetailsTips: '点击查看详情',
    dragFile: '拖拽文件至此或者',
    importTip: '导入说明:文件必须为xls或xlsx格式，导入前务必先在组织架构中建立好部门。',
    importDocTip: '添加后，该文档将作为AI助理的知识库。【支持doc/docx，最大10Mb】',
    downloadTemplate: '下载模板',
    downloadFailTemplate: '下载失败列表',
    importSuccess: '本次导入成功',
    importFail: '失败',
    importUnit: '条',
    dragTips: '拖拽图片可排序',
    aiAssistantTips: '建议添加3~5个默认问题，可获得最佳用户体验。',
    staffKeysTips: '支持设置员工可修改的字段'
  },
  setting: {
    wxaudit: '小程序审核状态设置',
    version: '小程序审核版本号',
    audting: '审核中',
    projectSetting: '项目配置',
    interfaceShow: '界面显示',
    themeColor: '主题颜色',
    darkTheme: '深色主题',
    menuMode: '深色菜单栏',
    breadCrumb: '显示面包屑',
    menuUnique: '菜单手风琴模式',
    navTab: '显示标签页',
    navTabIcon: '显示标签页图标',
    grayMode: '灰色模式',
    animateMode: '动画类型',
    tips: '提示',
    searchPanel: '搜索面板',
    staffKeys: '员工字段设置',
    DepartmentalMigration: '部门迁移',
    departmentTip: '原部门如果选择父级，会将子类部门及部门下的员工全部迁移',
    delDepartment: '迁移过后是否删除旧部门',
    oldDepartment: '旧部门',
    newDepartment: '新部门'
  },
  menus: {
    dashboard: '首页',
    analysis: '分析页',
    workbench: '工作台',
    multilevelMenu: '多级菜单',
    secondMenu: '二级菜单',
    thirdMenu: '三级菜单',
    systemManagement: '系统管理',
    menuManagement: '菜单管理',
    roleManagement: '角色管理',
    userManagement: '用户管理',
    externalPage: '外部页面',
    juejinPage: '掘金社区(外链)',
    elementDocs: 'element-plus 文档',
    errorPage: '错误页面',
    403: '403',
    404: '404',
    500: '500',
    about: '关于项目',
    feature: '功能示例',
    directives: '指令',
    watermark: '水印',
    selectIcon: '图标选择器',
    product: '产品',
    material: '物料管理',
    materialProduct: '产品库',
    materialProductEdit: '产品编辑',
    materialFile: '文件',
    materialBrochure: '宣传册',
    materialBrochureEdit: '宣传册编辑',
    materialCase: '案例',
    materialCaseEdit: '案例编辑',
    materialVideo: '视频',
    materialVideoEdit: '视频编辑',
    materialConfigCategory: '分类配置',
    customize: '小程序装修',
    customize_visitConfig: '访问设置',
    customizeMiniapp: '名片装修',
    customizeMiniappEdit: '名片装修详情',
    customizeWebsiteList: '页面装修',
    customizeWebsiteEdit: '页面装修详情',
    customizeModule: '模块装修',
    customizeNav: '导航设置',
    customizeTheme: '主题色',
    customer: '线索管理',
    customer_clue: '线索管理',
    customer_customer: '客户管理',
    customer_detail: '线索/客户详情',
    customer_configFollowStatus: '生命周期设置',
    customer_customerTag: '客户标签',
    company: '企业管理',
    company_staff: '员工管理',
    companyStaffAdd: '新增员工',
    companyStaffDetail: '员工详情',
    company_role: '角色管理',
    company_menu: '菜单管理',
    company_workHandover: '工作交接',
    company_company: '企业信息',
    announcement: '企业公告',
    announcement_index: '公告列表',
    announcementDetail: '公告详情',
    ai: '人工智能',
    ai_textToImage: '文生图',
    ai_aiVoice: 'AI声音',
    aiAssistant: 'AI助理',
    dataStatistics: '数据统计',
    materialPoster: '海报',
    materialPosterEdit: '海报编辑',
    materialArticle: '文章',
    materialArticleEdit: '文章编辑',
    materialDynamic: '动态',
    materialDynamicEdit: '动态编辑',
    tabKnowledge: '知识库'
  },
  login: {
    login: '登录',
    loginOut: '退出登录',
    register: '注册',
    remember: '记住密码',
    forgetPassword: '忘记密码?',
    changePassword: '修改密码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    passwordValidCheckMsg: '请输入包含大小写英文字母、数字且大于等于8位的密码',
    loginSuccess: '登录成功',
    welcomeBack: '欢迎回来',
    loginOutHint: '您确定要退出登录吗',
    accountNoPermissonHint: '当前账号无管理端角色权限，请联系管理员处理',
    pleaseInputOldPassword: '请输入原密码',
    pleaseInputNewPassword: '请输入新密码',
    pleaseInputNewPasswordAgain: '请再次输入新密码',
    theTwoNewPasswordsYouEnteredDoNotMatch: '两次新密码的输入不匹配',
    modificationSuccessfulPleaseLoginAgain: '修改成功，请重新登录',
    selectCompanyTips: '请选择登录的企业'
  },
  analysis: {
    staffBusinessCards: '员工名片数',
    staffPromotions: '员工推广次数',
    numberOfVisitors: '来访人数',
    totalClueCustomers: '线索/客户总数',
    todayAdd: '今日新增',
    thisWeekAdd: '本周新增',
    contentMostFrequentlyVisitedByCustomers: '客户最常访问内容',
    numberOfVisits: '访问次数',
    staffRanking: '员工排行',
    clueAdd: '新增线索',
    shareTimes: '分享次数',
    customerVisitRecordDetail: '访客浏览记录[明细]',
    customerDataDetail: '客户/线索列表[明细]',
    cardShareRecordDetail: '销售分享记录[明细]',
    cardShareStatistics: '销售分享统计[汇总]'
  },
  material: {
    name: '物料',
    productName: '产品名称',
    productPrice: '产品价格',
    productSecondaries: '二级分类',
    productThird: '三级分类',
    coverPicture: '封面图',
    pleaseSetNotAvailableItBeforeDeletingIt: '请先下架后再删除',
    pleaseSetAvailableItBeforeShowQRCode: '请先上架后再查看二维码',
    folder: '文件夹',
    rootDirectory: '根目录',
    currentDirectory: '当前目录',
    directory: '目录',
    isPreview: '是否可预览',
    visibleType: '可见类型',
    rename: '重命名',
    visibleToEveryone: '全员可见（包括全体员工）',
    visibleToDesignatedStaffs: '指定员工可见',
    visibleToDesignatedDep: '指定部门可见',
    listPicture: '列表图',
    relatedMaterialQuantity: '关联物料数量',
    deleteCategoryTips: '请先与关联物料解绑后再删除',
    deleteCategoryTips2: '该分类下有二级分类，不可删除',
    associatedFiles: '关联文件',
    useDefaultBackground: '使用默认背景',
    customBackground: '自定义背景',
    importContent: '导入内容',
    continueImporting: '继续导入',
    conversionCompleted: '已转换完成',
    fixedComponentArea: '固定组件',
    businessComponentArea: '业务组件',
    basicComponentArea: '基础组件',
    SpecComponentArea: '更多组件',
    relatedMaterialList: '关联物料列表',
    selectMaterial: '选择物料',
    attributesArea: '属性区域',
    selectedList: '已选择',
    targetArea: '',
    selectAttrAreaMaterialTips: '请在右侧选择物料',
    selectAttrAreaImageTips: '请在右侧配置属性',
    selectAttrAreaVideoAndImageTips: '请在右侧添加视频地址和封面',
    selectAttrAreaCarouselImageTips: '请在右侧添加轮播图',
    materialsSection: '物料板块',
    corporateStyle: '企业风采',
    videoSection: '视频板块',
    audio: '音频',
    sourceName: '来源名称'
  },
  customer: {
    lastVisitTime: '最后访问时间',
    visitType: '访问类型',
    followState: '跟进状态',
    becomeCustomerTime: '成为客户时间',
    currentFollowState: '当前跟进状态',
    lastFollowTime: '最后跟进时间',
    followTime: '跟进时间',
    status: '阶段',
    noMovementAllowed: '不允许移动',
    noEditAllowed: '不允许修改',
    noDeleteAllowed: '不允许删除',
    giveUp: '放弃',
    makeADeal: '成交',
    ordinaryMode: '普通节点',
    visitOverview: '访问概览',
    browsingContentStatistics: '浏览内容统计',
    mostInterestingContent: '最感兴趣内容',
    visitRecord: '访问记录',
    followRecord: '跟进状态',
    totalVisitDuration: '访问总时长(秒)',
    listpage: '列表页',
    nextStep: '下一步',
    listpageTip: '此页仅供预览，不支持动态交互。'
  },
  config: {
    searchAccessSettings: '搜索访问设置',
    searchInDefaultCard: '通过搜索首次进入小程序时展示的销售名片',
    randomCard: '随机进入一个员工名片',
    fixedCard: '进入指定员工的名片',
    selectCardTips: '请选择默认销售名片',
    businessEdition: '商务版',
    simpleEdition: '简约版',
    minimalistEdition: '极简版',
    professionalEdition: '专业版',
    lookingUpEdition: '仰望版',
    customizeThemeTip: '设置主题色后，小程序端主要按钮的颜色都将随之变化'
  },
  announcement: {
    specifiedPerson: '指定人员',
    everyone: '所有人',
    allSales: '所有销售',
    allReferralOfficers: '所有推荐官',
    referralOfficers: '推荐官',
    readTime: '查看时间',
    announcementRecipientList: '公告接收人列表'
  },
  company: {
    valid: '有效期至',
    aiCardSwitch: 'ai名片开关',
    aiVideo: 'ai数字人效果图',
    aiVideoStatusfu1: '未上传形象照',
    aiVideoStatus0: 'AI生成中',
    aiVideoStatus1: 'AI生成完成',
    aiVideoStatus2: 'AI生成失败',
    aiCardUseTips: '请联系系统提供商开通AI功能后即可使用',
    pleaseSetDisableBeforeDelete: '请先关闭名片后再删除',
    pleaseSetEnableBeforeShowQRCode: '请先启用名片再查看二维码',
    addDepartmentNameErrorTips: '部门名称不能为空或空格',
    deleteDepartmentErrorTips: '个子部门，请先清理子部门后再进行删除',
    numberOfRelatedMenus: '关联菜单数',
    numberOfRelatedUsers: '关联用户数',
    superAdminAreNotAllowedToEdit: '超级管理员不允许编辑',
    superAdminAreNotAllowedToDelete: '超级管理员不允许删除',
    menu: '菜单',
    initiateHandover: '发起交接',
    handoverParty: '交出方',
    receiver: '接收方',
    handoverTips: '交接后交出方数据会转给接受方，交出方会被删除，您确认要发起交接吗？',
    pleaseSelectStaff: '请选择员工',
    handoverRepeatTips: '交出方和接收方不能相同，请重新选择',
    handoverFinish: '交接完成',
    selectHandoverPartyTips: '交出方必须先关闭名片才能交接',
    selectReceiverPartyTips: '接收方必须打开名片才能交接',
    companyShortName: '公司简称',
    companyFullName: '公司全称',
    companyAddress: '公司地址',
    website: '企业网站',
    stockCode: '股票代码',
    companyLogo: '企业Logo',
    companyShortNameLengthTips: '企业简称不能超过10个字符',
    companyFullNameLengthTips: '企业全称不能超过40个字符',
    companyAddressLengthTips: '公司地址不能超过50个字符',
    companyLogoLengthTips: '企业Logo不能超过400个字符',
    roleNameLengthTips: '角色名称不能超过10个字符',
    roleDescLengthTips: '角色描述不能超过30个字符',
    cardShowingMobileNumber: '名片展示手机号',
    userRoleSettings: '用户角色设置',
    enterYourLoginPassword: '填写登录密码',
    superAdminRole: '系统超管',
    companyAdminRole: '公司管理员',
    departmentAdminRole: '部门角色',
    externalPhone: '对外手机号',
    junior: '下级'
  }
};
